export enum UserType {
  B2bBaseUser = 'b2bBaseUser',
  B2bHeyObiUser = 'b2bHeyObiUser',
  BaseUser = 'baseUser',
  HeyObiUser = 'heyObiUser',
  SessionUser = 'sessionUser',
}
